import { render, staticRenderFns } from "./EditVehicle.vue?vue&type=template&id=19620272&"
import script from "./EditVehicle.vue?vue&type=script&lang=js&"
export * from "./EditVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports